export function secondsToString(seconds) {
  const numhours = Math.floor(seconds / 3600);
  seconds -= numhours * 3600;
  const numminutes = Math.floor(seconds / 60);
  let numseconds = Math.floor((seconds - numminutes * 60) * 100) / 100;
  if (numseconds < 10) {
    numseconds = `0${numseconds}`;
  }
  if (numhours === 0) {
    if (numminutes > 0) {
      return `${numminutes}:${numseconds}`;
    }
    return `0:${numseconds}`;
  }
  let str = `${numminutes}:${numseconds}`;
  if (numminutes < 10) {
    str = `0${str}`;
  }
  return `${numhours}:${str}`;
}

export function parseTime(time) {
  let seconds = 0;
  const sections = time.split(':');
  for (let i = 0; i < sections.length; i += 1) {
    const multiplier = Math.pow(60, i);
    let value = sections[sections.length - 1 - i];
    if (value === '') {
      value = '0';
    }
    seconds += parseFloat(value) * multiplier;
  }
  return seconds;
}
